import { Stack, Typography } from '@mui/material';
import React from 'react';
import BackButton from '../../../common/BackButton';

const CountryViewLander = ({ navigate }) => {
  return (
    <Stack
      direction="row"
      gap={2}
      alignItems="center"
      sx={{ paddingBottom: 2 }}
    >
      <BackButton onClick={() => navigate(-1)} />

      <Typography variant="h4">Country Code Information</Typography>
    </Stack>
  );
};

export default CountryViewLander;
